import Model from "../Model";
import ValidatableObject from "../validation/ValidatableObject";

export interface TNotice {
  languageCode: string;
  summary: string;
  title: string;
  urlLink: string;
}

export interface INotice extends TNotice {}

const Notice = Model(
  (model: TNotice): INotice => {
    const _notice: TNotice = Object.assign({}, model);

    let create = (notice: INotice): INotice => {
      let obj = ValidatableObject(notice);
      return obj;
    };

    let notice = {
      get languageCode() {
        return _notice.languageCode;
      },
      get summary() {
        return _notice.summary;
      },
      get title() {
        return _notice.title;
      },
      get urlLink() {
        return _notice.urlLink;
      }
    };

    return create(notice);
  }
);

export default Notice;
